import _ from 'lodash';
import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { FormikProps } from 'formik';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { parseLov } from '../../../global/helpers/form-data-helper';
import { FormField } from '../../../global/components/form-element/form-field';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioMinistry, ClergyBioPosition } from '../model/clergy-bio-app-models';
import { YesNoIndicators } from '../../../global/models/api-model';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';


interface Props {
	settings: ClergyBioSettings;
	id: string;
	parentArrayField: string;
	parentArrayId: string;
	arrayField: string;
	formikProps: FormikProps<any>;
	employment: ClergyBioMinistry;
	defaultValue: ClergyBioPosition;
	errors?: any;
	setList?: any;
}


function ClergyBioPositionItem(props: Props) {

	const { settings, arrayField, id, formikProps, setList, employment, parentArrayField, parentArrayId, defaultValue, errors } = props;
	const buttonClasses = buttonStyles();

	const positionTitles = useSelector<TcsmStates, any>(state => state.lovProcState?.personLov?.position_title);
	const positionTitleOptions = positionTitles ? parseLov(positionTitles, true) : [];

	const remove = () => {
		if (defaultValue?.id) {
			const list = _.cloneDeep(formikProps?.values[parentArrayField][parentArrayId][arrayField]);
			const toDelete = { ...defaultValue };
			toDelete.deleted = YesNoIndicators.Yes;
			list[id] = toDelete;
			const copy = { ...formikProps?.values };
			copy[parentArrayField][parentArrayId][arrayField] = list;
			setList(copy);
		} else {
			const list = formikProps?.values[parentArrayField][parentArrayId][arrayField];
			list.splice(Number(id), 1);
			const copy = { ...formikProps?.values };
			copy[parentArrayField][parentArrayId][arrayField] = list;
			setList(copy);
		}
	};

	if (employment[arrayField][id].deleted === YesNoIndicators.Yes) {
		return null;
	}

	return (
		<>
			{
				errors &&
				<ContentSpacer>
					<Banner
						banner={{
							type: 'error',
								label: <p><strong>{Object.keys(errors).map(k => errors[k][0]).join(', ')}</strong></p>,
						}}
					/>
				</ContentSpacer>
			}
			<FormField
				name={`${parentArrayField}.${parentArrayId}.${arrayField}.${id}.position`}
				options={positionTitleOptions}
				label={settings?.positionTitleLabel}
				component='input'
				touched={formikProps.touched}
				errors={formikProps.errors}
				select
				required
			/>
			<FormField
				name={`${parentArrayField}.${parentArrayId}.${arrayField}.${id}.publishedPosition`}
				label={settings.publishedPositionLabel}
				component='input'
				touched={formikProps.touched}
				errors={formikProps.errors}
			/>
			<FormField
				name={`${parentArrayField}.${parentArrayId}.${arrayField}.${id}.dateBegan`}
				label={settings?.positionStartDateLabel}
				component='datePicker'
				touched={formikProps.touched}
				errors={formikProps.errors}
				required
				autoWidth
			/>
			<FormField
				name={`${parentArrayField}.${parentArrayId}.${arrayField}.${id}.dateEnded`}
				label={settings?.positionEndDateLabel}
				component='datePicker'
				touched={formikProps.touched}
				errors={formikProps.errors}
				autoWidth
			/>

      {employment?.[arrayField]?.filter(pos => pos.deleted !== YesNoIndicators.Yes).length > 1 && (
        <div className='form-item'>
          <button className={buttonClasses.linkButton} type='button' onClick={() => remove()} >
            {settings?.removeChildButtonText}
          </button>
        </div>
      )}
		</>
	);
}

ClergyBioPositionItem.defaultProps = {
	errors: null,
	setList: null,
};
export default ClergyBioPositionItem;
